import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

/**
 * SVG icon representing L3 concentrations
 */

export interface ConcentrationsIconProps {
    colors: string[];
}

const ConcentrationsIcon = ({ colors, sx }: SvgIconProps & ConcentrationsIconProps) => {
    return (
        <SvgIcon sx={[...(Array.isArray(sx) ? sx : [sx])]}>
            <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="5" height="5" transform="matrix(1 0 0 -1 0 20)" fill={colors[0]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 5 20)" fill={colors[5]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 10 20)" fill={colors[2]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 15 20)" fill={colors[5]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 20 20)" fill={colors[0]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 25 20)" fill={colors[0]} />

                <rect width="5" height="5" transform="matrix(1 0 0 -1 0 15)" fill={colors[0]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 5 15)" fill={colors[1]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 10 15)" fill={colors[4]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 15 15)" fill={colors[2]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 20 15)" fill={colors[4]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 25 15)" fill={colors[0]} />

                <rect width="5" height="5" transform="matrix(1 0 0 -1 0 10)" fill={colors[0]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 5 10)" fill={colors[5]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 10 10)" fill={colors[4]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 15 10)" fill={colors[3]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 20 10)" fill={colors[2]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 25 10)" fill={colors[1]} />

                <rect width="5" height="5" transform="matrix(1 0 0 -1 0 5)" fill={colors[0]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 5 5)" fill={colors[3]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 10 5)" fill={colors[4]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 15 5)" fill={colors[3]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 20 5)" fill={colors[2]} />
                <rect width="5" height="5" transform="matrix(1 0 0 -1 25 5)" fill={colors[1]} />
            </svg>
        </SvgIcon>
    );
};

export default ConcentrationsIcon;
